import { jsxs, jsx } from "react/jsx-runtime";
const NoResultsAvailableIcon = () => /* @__PURE__ */ jsxs("svg", { width: "200", height: "180", viewBox: "0 0 200 180", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M53.708 35.6579L65.4296 28.9557C71.065 25.7162 78.6164 25.4928 87.1822 28.844L75.4606 35.5462C66.8948 32.1951 59.3434 32.4185 53.708 35.6579Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M183.209 155.181L171.487 161.883C176.897 158.756 180.278 152.277 180.278 143.005C180.391 125.803 168.895 104.914 153.679 93.297L165.401 86.5947C180.617 98.212 192 119.101 192 136.303C192 145.575 188.732 152.053 183.209 155.181Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M84.5898 24.3757L96.3114 17.6734C103.637 13.4287 114.119 14.0989 125.615 20.6894C147.593 33.312 165.289 62.6903 165.401 86.7067L153.68 93.4089C153.567 69.5042 135.872 40.0143 113.894 27.3917C102.398 20.8012 91.9158 20.1309 84.5898 24.3757Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M153.68 93.2972C153.567 69.3925 135.872 39.9025 113.894 27.28C96.0861 17.1149 80.7579 21.0245 75.5733 35.4344C57.202 28.2853 43.4516 37.5567 43.3389 58.222C43.2262 81.2331 60.4705 109.718 81.7722 121.893C82.8993 122.564 84.0264 123.122 85.1535 123.681L147.594 159.538C148.157 159.873 148.721 160.096 149.171 160.208C166.416 169.256 180.166 161.772 180.166 143.117C180.391 125.803 168.895 104.914 153.68 93.2972Z",
      fill: "url(#paint0_linear_6211:33717)"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M47.9228 156.521V119.606H35.0088V156.521C35.0088 157.473 35.6729 158.426 36.9274 159.158C39.4364 160.623 43.5689 160.623 46.0779 159.158C47.3324 158.426 47.9228 157.473 47.9228 156.521Z",
      fill: "#DCDCDC"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M46.0781 116.97C48.5871 118.435 48.5871 120.778 46.0781 122.243C43.5691 123.708 39.4366 123.708 36.9276 122.243C34.4186 120.778 34.3448 118.435 36.9276 116.97C39.4366 115.505 43.4953 115.505 46.0781 116.97Z",
      fill: "#787878"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M44.3067 106.423C42.757 105.544 40.1742 105.544 38.6246 106.423C37.8128 106.862 37.4438 107.448 37.4438 108.034V118.801C37.4438 119.387 37.8128 119.973 38.6246 120.412C40.1742 121.291 42.757 121.291 44.3067 120.412C45.1184 119.973 45.4874 119.387 45.4874 118.801V108.034C45.4874 107.448 45.1184 106.862 44.3067 106.423Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M46.8896 96.9747C34.2708 89.7236 24.0873 72.2183 24.0873 57.7894C24.0873 50.6115 26.6701 45.6309 30.7287 43.2139L20.0286 49.4396C15.8961 51.7834 13.3871 56.8372 13.3871 64.0151C13.3133 78.4441 23.4969 95.9493 36.1157 103.2C42.462 106.863 48.2179 107.156 52.3504 104.812L63.0505 98.5861C58.9919 101.003 53.2359 100.637 46.8896 96.9747Z",
      fill: "#787878"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: "0.4",
      d: "M39.2891 101.296C51.9079 108.547 62.1653 102.76 62.2391 88.3314C62.3128 73.9024 52.0555 56.3972 39.4367 49.1461C26.8179 41.895 16.5605 47.6812 16.4867 62.1102C16.4129 76.466 26.6703 94.0444 39.2891 101.296Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M36.3372 44.8984C51.9078 53.8341 64.5266 75.5142 64.5266 93.3124C64.4528 111.111 51.7602 118.289 36.1897 109.353C20.5453 100.417 7.92653 78.737 8.00032 60.9388C8.07412 43.1405 20.7667 35.9627 36.3372 44.8984ZM36.1159 103.127C48.7347 110.378 58.992 104.592 59.0658 90.163C59.1396 75.734 48.8822 58.2287 36.2635 50.9776C23.6447 43.7265 13.3873 49.5127 13.3135 63.9417C13.2397 78.3707 23.4971 95.9492 36.1159 103.127Z",
      fill: "#DCDCDC"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M46.9636 38.8191C39.0676 34.3512 31.9834 33.9117 26.8178 36.9147L16.1177 43.0672C21.2833 40.1374 28.3675 40.5037 36.1897 45.0448C51.7602 53.9805 64.379 75.6606 64.379 93.4588C64.379 102.321 61.2059 108.547 56.1141 111.477L66.8142 105.251C71.906 102.321 75.0054 96.0956 75.0791 87.2331C75.1529 69.5081 62.5342 47.828 46.9636 38.8191Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
    "linearGradient",
    {
      id: "paint0_linear_6211:33717",
      x1: "103.306",
      y1: "43.7434",
      x2: "80.0151",
      y2: "180.054",
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#F4F4F4" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#C9C9C9" })
      ]
    }
  ) })
] });
export {
  NoResultsAvailableIcon
};
//# sourceMappingURL=NoResultsAvailableIcon.js.map
